import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-aangever',
  standalone: true,
    imports: [CommonModule, SharedUiAlertModule],
  templateUrl: './tekst-aangever.component.html',
  styleUrl: './tekst-aangever.component.scss',
})
export class TekstAangeverComponent {}
